let initialState = {
	slides: [],
	activeSlide: 0,
};

export const slideList = (state = initialState, action) => {
	switch (action.type) {
		case "UPDATE_ACTIVE_SLIDE":
			return {
				...state,
				activeSlide: action.activeSlide,
			};

		case "UPDATE_SLIDES":
			return {
				...state,
				slides: action.slides,
			};

		default:
			return state;
	}
};
